module.exports = __webpack_public_path__ + "img/slide-2.3eb40dfc.webp";